import React, { Component } from 'react';
import Autocomplete from 'react-autocomplete';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import {
  createSupplierAutomation,
  updateSupplierAutomation,
} from '../../app/store/actions/supplierAutomation';
import {
  createSupplierTelecom,
  getSupplierTelecomOptions,
  updateSupplierTelecom,
} from '../../app/store/actions/supplierTelecom';
import FIELDS from '../../data/fields';

let selectedHelper = '';

class SupplierTelecomForm extends Component {
  constructor(props) {
    super(props);
    this.actions = {
      update: 'updateSupplierTelecom',
      create: 'createSupplierTelecom',
    };
    this.state = {
      id: null,
      editSupplierTelecom: false,
      isLoading: false,
      mainProvider: false,
      messageError: '',
      messageSuccess: '',
      provider: '',
      brandId: '',
      listProviders: [],
    };
  }

  componentDidMount = async () => {
    if (this.props.back.location.selectedSupplierTelecom) {
      await this.setSelectedSupplierTelecom(this.props.back.location.selectedSupplierTelecom);
    }
    const listProviders = await this.props.getSupplierTelecomOptions('', true);
    this.setState({ listProviders: listProviders || [] });

    if (this.props.back.location.actions) {
      this.actions.create = this.props.back.location.actions.create;
      this.actions.update = this.props.back.location.actions.update;
    }
  }

  setValue = (att, value) => {
    if (value && value < 0) {
      this.setState({ [att]: Math.abs(value) });
    } else {
      this.setState({ [att]: value });
    }
  }

  goBack = () => {
    this.props.back.goBack();
  };

  createSupplierTelecom = async () => {
    this.setState({ isLoading: true });
    const {
      brandId, mainProvider,
    } = this.state;

    if (!brandId) {
      this.setState({ messageError: I18n.t('fieldsNotReported') });
      this.setState({ isLoading: false });
      return;
    }

    try {
      await this.props[this.actions.create]({
        brandId, mainProvider,
      });

      await this.setState({ messageSuccess: I18n.t('registrationPerformed') });
      await this.goBack();
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;
      this.setState({ messageSuccess: '' });

      if (error && error.message) {
        const messageError = (error.code && error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({ messageError });
      } else {
        this.setState({ messageError: I18n.t('errorOcurred') });
      }
    }
    this.setState({ isLoading: false });
  }

  setSelectedSupplierTelecom = async (selectedSupplierTelecom) => {
    this.setState({

      editSupplierTelecom: true,
      id: selectedSupplierTelecom.id,
      brandId: selectedSupplierTelecom.brandId,
      mainProvider: selectedSupplierTelecom.mainProvider,
      provider: selectedSupplierTelecom.brand.description,
    });
  }

  updateSupplierTelecom = async () => {
    this.setState({ isLoading: true });
    const {
      id, brandId, mainProvider,
    } = this.state;
    if (!id || !brandId) {
      this.setState({ messageError: I18n.t('fieldsNotReported') });
      this.setState({ isLoading: false });
      return;
    }

    try {
      await this.props[this.actions.update]({
        id, brandId, mainProvider,
      });

      await this.setState({ messageSuccess: I18n.t('changeMade') });
      await this.goBack();
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;
      this.setState({ messageSuccess: '' });

      if (error && error.message) {
        const messageError = (error.code && error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({ messageError });
      } else {
        this.setState({ messageError: I18n.t('errorOcurred') });
      }
    }
    this.setState({ isLoading: false });
  }

  setSelectedField = (item) => {
    selectedHelper = item;
    return item.description;
  };

  setSelectedFieldId = (value) => {
    this.setState({
      provider: value,
      brandId: selectedHelper.id,
    });
  };

  setOnChangeProvider = async (value) => {
    const listProviders = await this.props.getSupplierTelecomOptions(value, false);
    this.setState({ listProviders: listProviders || [], provider: value });
  };

  render() {
    const {
      isLoading, messageSuccess, listProviders, provider, messageError, editSupplierTelecom, mainProvider,
    } = this.state;

    return (
      <div className="form-main">
        <h2 className="header-form-client">
          {I18n.t('supplierTelecomRegistration')}
        </h2>
        <form>
          <div className="form-group search-custom-input">
            <p className="margin-bottom-2">
              {I18n.t('supplier')}
            </p>
            <Autocomplete
              getItemValue={item => this.setSelectedField(item)}
              items={listProviders || []}
              className="custom-select"
              maxLength={FIELDS.max}
              renderItem={(item, isHighlighted) => (
                <div key={item.code} style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                  {item.description}
                </div>
              )}
              value={provider}
              onChange={e => this.setOnChangeProvider(e.target.value)}
              onSelect={e => this.setSelectedFieldId(e)}
            />
          </div>
          <div className="d-flex flex-column align-items-start form-group search-custom-input margin-bottom-10">
            <span className="margin-bottom-2">
              {I18n.t('mainProvider')}
            </span>
            <input
              checked={mainProvider}
              type="checkbox"
              onChange={e => this.setState({ mainProvider: e.target.checked })}
            />
          </div>

          {!!messageSuccess && <p className="color-green margin-top-10">{messageSuccess}</p>}
          {!!messageError && <p className="color-red margin-top-10">{messageError}</p>}

          <div className="row margin-left-0 margin-top-10">
            <button
              type="button"
              onClick={() => this.goBack()}
              className="btn btn-warning margin-right-15"
            >
              {I18n.t('return')}
            </button>

            <button
              type="button"
              className="btn btn-dark"
              onClick={() => ((!editSupplierTelecom) ? this.createSupplierTelecom() : this.updateSupplierTelecom())}
              disabled={isLoading}
            >
              {(!editSupplierTelecom) ? I18n.t('toSend') : I18n.t('resend')}
            </button>
          </div>
        </form>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  createSupplierTelecom: newSupplierTelecom => dispatch(createSupplierTelecom(newSupplierTelecom)),
  getSupplierTelecomOptions: (search, loading) => dispatch(getSupplierTelecomOptions(search, loading)),
  updateSupplierTelecom: updSupplierTelecom => dispatch(updateSupplierTelecom(updSupplierTelecom)),
  createSupplierAutomation: newSupplierTelecom => dispatch(createSupplierAutomation(newSupplierTelecom)),
  updateSupplierAutomation: updSupplierTelecom => dispatch(updateSupplierAutomation(updSupplierTelecom)),
});

const mapStateToProps = () => ({
});


export default connect(mapStateToProps, mapDispatchToProps)(SupplierTelecomForm);
